/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  padding: 40px;
  display: flex;
  flex: 1;
  flex-direction: column;

  width: 100%;
  height: 100vh;
`;

export const Card = styled.div`
  background: #fff;
  border: 1px solid #000;
  border-radius: 5px;

  margin: 10px 0px 0px 0px;

  padding: 15px;

  div.content {
    display: flex;
    flex-direction: row;
    div.position {
      width: 10%;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        font-size: 24px;
      }
    }

    div.support {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 70%;

      div.title {
        width: 40%;
      }

      div.description {
        width: 60%;
      }
    }

    button {
      background: #36ded6;
      padding: 10px;
      width: 20%;
      margin-left: 30px;
      font-weight: bold;
      height: 50px;
      align-self: center;
      border: none;
      border-radius: 5px;
    }
  }
`;

export const ContainerFailed = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  button {
    background: rgba(0, 0, 0, 0);
    width: 150px;
    padding: 10px;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 600px;
  }
`;
